<button type="button"
        class="xp-expander__toggle"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="expanded() ? bodyId : null"
        (click)="toggle()">
	<mat-icon class="xp-expander__chevron">{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
	<span class="xp-expander__title">{{ heading() }}</span>
	<ng-content select="[xpExpanderAside]"></ng-content>
</button>
<div class="xp-expander__body" [id]="bodyId" [hidden]="!expanded()"><ng-content></ng-content></div>
